<template>
  <div class="item-main">
    <div style="display: flex">
      <i class="fa-regular fa-file-lines" style="margin-right: 8px; font-size: 18px;"></i>
      <div
        class="c-uploader-progress-bg"
        :style="fileProgressPercent"
        v-bind:class="file.__failed || file.__failedNoPassword ? 'c-uploader-progress-bg-negative' : ''"
      />
      <div
        class="c-uploader-file-name"
        v-bind:class="
          file.__failed || file.__failedNoPassword ? 'c-uploader-file-name-negative' : ''">
        {{ this.file.name }}
      </div>
      <!-- <div class="c-uploader-file-size">{{ this.file.__size }}</div> -->
      <v-input
        v-bind:class="[
          !file.__password ? 'c-uploader-spacer' : '',
          file.__password && file.__failedNoPassword && !file.password
            ? 'c-uploader-input invalid'
            : '',
          file.__password ? 'c-uploader-input' : '',
          file.__password && !file.__failedNoPassword && file.password
            ? 'c-uploader-input valid disabled'
            : ''
        ]"
        :ref="this.file.id + 'password'"
        type="password"
        :name="this.file.id + 'password'"
        :value="this.file.password"
        placeholder="Enter password"
        v-if="this.file.__password"
      ></v-input>
      <div
        v-else
        v-bind:class="[
          !file.__password ? 'c-uploader-spacer' : '',
          file.__password && file.__failedNoPassword && !file.password
            ? 'c-uploader-input invalid'
            : '',
          file.__password ? 'c-uploader-input' : '',
          file.__password && !file.__failedNoPassword && file.password
            ? 'c-uploader-input valid disabled'
            : ''
        ]"
        :ref="this.file.id + 'password'"
        type="password"
        :name="this.file.id + 'password'"
        :value="this.file.password"
        placeholder="Enter password"
      ></div>
      <div
        v-if="file.__password && file.__failedNoPassword && !file.password"
        class="c-uploader-button-invalid mr-10"
      >
        Could not validate the entered password. Please try again.
      </div>
      <div
        v-if="file.__password && !file.__failedNoPassword && file.password"
        class="c-uploader-button-valid mr-10"
      >
        <div>Password has been validated. Field has been temporary locked.</div>
        <v-icon size="20" color="#8BB84D"> mdi-checkbox-marked-circle </v-icon>
      </div>
      <div
        v-if="file.__password && !file.password"
        class="c-uploader-button-save mr-10"
        @click="this.onSavePassword"
      >
        Unlock
      </div>
      <div v-if="file.__failed" class="c-uploader-button-restart mr-10" @click="this.onRestart">
        <v-icon size="20" color="#8BB84D"> mdi-arrow-u-left-top</v-icon>
      </div>
      <div v-if="file.__progress !== 0" class="c-uploader-progress-text mr-10">
        {{ file.__progress + '%' }}
      </div>
      <div v-if="file.__doneUploading" class="c-uploader-button-remove cursor-pointer">
        <v-icon color="green"></v-icon>
      </div>
      <i
        v-else
        class="fa-solid fa-xmark"
        style="font-size: 18px; color: #161616; cursor: pointer"
        @click="this.onRemove"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CFile',
  props: ['file', 'uploadInProgress'],
  computed: {
    fileProgressPercent() {
      return 'width: ' + this.file.__progress + '%'
    }
  },
  methods: {
    onRemove() {
      this.$emit('onRemove', this.file)
    },
    onRestart() {
      this.$emit('onRestart', this.file)
    },
    onSavePassword() {
      this.$emit('onSavePassword', this.file, this)
    }
  }
}
</script>

<style scoped>
.item-main {
  border: 1px solid #C9CBD5;
  border-radius: 8px;
  margin-top: 10px;
  padding: 10px 16px;
}
.c-uploader-progress-bg {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  background: red;
  /* background-color: #e3eed5; */
  transition: width 0.3s linear;
}
.c-uploader-progress-bg-negative {
  background-color: #db2828;
  opacity: 0.1;
}
.c-uploader-file-name {
  z-index: 1;
  color: #161616;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  letter-spacing: 0.01em;
}
.c-uploader-file-name-negative {
  color: #777777;
}
.c-uploader-file-size {
  z-index: 1;
  white-space: nowrap;
  font-size: 0.875rem;
  color: #777777;
  margin-right: 10px;
  margin-left: 10px;
}
.c-uploader-spacer {
  flex: 1;
}
.c-uploader-input {
  flex: 1;
  margin-right: 10px;
  width: 100px;
  border-radius: 5px;
  border: 2px solid #777777;
  background-color: white;
}

.c-uploader-input.focus {
  outline: none;
}

.c-uploader-input.invalid {
  border: 2px solid red;
}

.c-uploader-input.valid {
  pointer-events: none;
  borde: 2px solid gray;
}

.c-uploader-button-valid {
  z-index: 1;
  font-size: 0.875rem;
  color: #21ba45;
}
.c-uploader-button-invalid {
  z-index: 1;
  font-size: 0.875rem;
  color: #d0021b;
}
.c-uploader-button-save {
  z-index: 1;
  height: 25px;
  cursor: pointer;
  font-size: 0.875rem;
  color: black;
  border-radius: 5px;
  border: 2px solid #bdbdbd;
  padding: 2px 6px;
}

.c-uploader-button-save.hover {
  cursor: pointer;
  background: #bdbdbd;
}

.c-uploader-button-restart {
  z-index: 1;
  cursor: pointer;
  font-size: 0.875rem;
  color: #bdbdbd;
}

.c-uploader-progress-text {
  width: 30px;
  text-align: right;
  z-index: 1;
  font-size: 0.875rem;
}
.c-uploader-button-remove {
  z-index: 1;
  cursor: pointer;
  font-size: 0.875rem;
  color: #bdbdbd;
}
</style>
